module.exports = __webpack_public_path__ + "static/media/background.7863ce7f.png";